const resource = 'variants'

export default $axios => ({
  fetch(params) {
    return $axios.$get(`/${resource}`, { params })
  },

  getServiceName: name => 'variantService',
})
